import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import trackEvent from '@99designs/common/utils/platform/trackEvent';

export default function TrackClick(props) {
    const el = useRef(null);
    const delay = 300;

    function track() {
        trackEvent('Element Clicked On Design Overlay', {
            ...props.payload,
            element: props.element,
        });
    }

    function delayNavigation(e, link) {
        e.preventDefault();
        e.stopPropagation();
        setTimeout(() => {
            window.location.href = link.getAttribute('href');
        }, delay);
    }

    // Mimics the delay from segments trackLink
    useEffect(() => {
        const listeners = [];

        el.current.addEventListener('click', track, true);
        const links = el.current.querySelectorAll('a');
        Array.from(links).forEach(link => {
            const listener = e => delayNavigation(e, link);
            link.addEventListener('click', listener);
            listeners.push({ link, listener });
        });

        return () => {
            el.current.removeEventListener('click', track, true);
            Array.from(listeners).forEach(({ link, listener }) => {
                link.removeEventListener('click', listener);
            });
        };
    });

    return <span ref={el}>{props.children}</span>;
}

TrackClick.defaultProps = {
    payload: {},
};

TrackClick.propTypes = {
    element: PropTypes.string.isRequired,
    payload: PropTypes.object,
    children: PropTypes.node.isRequired,
};



// WEBPACK FOOTER //
// ./src/js/apps/ddo/components/TrackClick.jsx